import axios from 'axios'

export const getRfq = (page, type, perPage) => {
  return axios.get(`quotation/list/${page}/${type}/${perPage}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getRfqFilter = (page, type, perPage, filter, key) => {
  return axios.get(`quotation/filter/${page}/${type}/${perPage}/${filter}/${key}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getRfqById = (id) => {
  return axios.get(`quotation/get/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getBid = (id) => {
  return axios.get(`bid/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getBidPrice = (id) => {
  return axios.get(`bidprice/get/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const postRfq = (data) => { // di ganti nama
  return axios.post('quotation/create', data)
    .then(res => {
      return res
    })
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const extendRfq = (data) => {
  return axios.put('quotation/resend_rfq', data)
    .then(res => {
      return res
    })
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const cancelRfq = ({id}) => {
  return axios.put('quotation/cancel', {id})
    .then(res => {
      return res
    })
    .catch(err => {
      console.log(err, err.response)
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/rfq.api.js